import {
  SFH_BASIC_ACCOUNT_INITIATED,
  SFH_IRA_UTMA_INITIATED,
  SFH_NON_PRIMARY_INITIATED,
  SFH_NON_US_INITIATED,
} from '../../constants/gtmEvents';
import { USER_ROLE_TYPES } from '../enum/api/accountTypes';

const AUTHORIZATION_LABELS = {
  [USER_ROLE_TYPES.FULL_ACCESS]: 'Full Access',
  [USER_ROLE_TYPES.READ_ONLY]: 'Read Only',
  [USER_ROLE_TYPES.NOTIFICATION_ONLY]: 'Notifications Only',
};

export const resolveSfhAuthorization = ({ authUser, accountUsers }) => {
  if (!authUser?.UserUid || !Array.isArray(accountUsers)) return undefined;
  const currentUserRow = accountUsers.find(
    (accountUser) => accountUser?.UserUid === authUser.UserUid,
  );
  if (!currentUserRow) return undefined;
  if (currentUserRow.IsPrimaryUser) return 'primary';
  return AUTHORIZATION_LABELS[currentUserRow.RoleType];
};

export const fireSfhInitiationEvent = (
  sfhGtmEvent,
  { isNonUS, isIraOrUtmaAccount, isJointSubUser, isBasicAccount, country },
) => {
  if (isIraOrUtmaAccount) {
    sfhGtmEvent(SFH_IRA_UTMA_INITIATED);
    return;
  }
  if (isJointSubUser) {
    sfhGtmEvent(SFH_NON_PRIMARY_INITIATED, { authorization: 'non_primary' });
    return;
  }
  if (isBasicAccount) {
    sfhGtmEvent(SFH_BASIC_ACCOUNT_INITIATED);
    return;
  }
  if (isNonUS) {
    sfhGtmEvent(SFH_NON_US_INITIATED, { country });
  }
};
